import {useNavigate} from 'react-router-dom';

import {AiOutlineEdit} from 'react-icons/ai';
import {FlexiButton, FlexiCancelButton} from '@flexinet/ui-components';
import {useVerifiedPermissions} from '@flexinet/auth-components';
import {rbacActions} from '../../../config/rbac/actions.ts';
import {moduleConfig} from '../config';

export const useEditPageTools = ({onEdit}: { onEdit: () => void }) => {

    const navigate = useNavigate();
    const {allowedActions} = useVerifiedPermissions();

    const tools = [];

    if (allowedActions.includes(rbacActions.UpdateSubscription)) {
        tools.push(
            <FlexiButton leftSection={<AiOutlineEdit/>} variant={'filled'} key={'edit'} onClick={onEdit}>
                Edit
            </FlexiButton>,
        );
    }

    tools.push(<FlexiCancelButton key={'close'} onClick={() => navigate(moduleConfig.basePath)}/>);

    return {tools};
};
